import type { PillTone } from "@buildpy/ui/pill";
import type { AsRequestStatus } from "@buildpy/core/modules/as-request/rules";

// A/S 상태 → 알약 색 — 고객·직원 화면이 같은 한 벌을 쓴다.
export const AS_STATUS_TONE: Record<AsRequestStatus, PillTone> = { OPEN: "new", SCHEDULED: "progress", DONE: "done" };
